// Employee Management Permissions

export const EMPLOYEES_INDEX = 57;
export const EMPLOYEES_SHOW = EMPLOYEES_INDEX; // Employee Profile Show
export const EMPLOYEES_CREATE = 58;
export const EMPLOYEES_EDIT = 59;
export const EMPLOYEES_DELETE = 60;
export const EMPLOYEES_RESTORE = 1380;
